import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import i18n from "i18next";
import { SettingsLayout } from "~/pages/settings/settings-layout";

export const Route = createFileRoute("/_app/settings")({
  head: () => ({ meta: [{ title: i18n.t("general:header.settings") }] }),
  beforeLoad: ({ context }) => {
    if (!context.auth.session?.user.isSuperAdmin) {
      throw redirect({ to: "/", replace: true });
    }
  },
  component: SettingsRoute,
});

function SettingsRoute() {
  return (
    <SettingsLayout>
      <Outlet />
    </SettingsLayout>
  );
}
